import { render, staticRenderFns } from "./Tipoelettrico.vue?vue&type=template&id=3adad812&"
import script from "./Tipoelettrico.vue?vue&type=script&lang=js&"
export * from "./Tipoelettrico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports